import React, { useState } from 'react';
import CameraFrame from '../../components/ui/CameraFrame';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiAlertTriangle, FiCheckCircle, FiLoader, FiInfo } = FiIcons;

const StateSimulator = () => {
  const [activeState, setActiveState] = useState('success');

  const states = [
    { id: 'loading', label: 'LOADING', icon: FiLoader, color: 'text-blue-400' },
    { id: 'success', label: 'SUCCESS', icon: FiCheckCircle, color: 'text-green-500' },
    { id: 'warning', label: 'WARNING', icon: FiAlertTriangle, color: 'text-yellow-500' },
    { id: 'error', label: 'ERROR', icon: FiAlertTriangle, color: 'text-red-500' },
    { id: 'empty', label: 'EMPTY', icon: FiInfo, color: 'text-[#666]' },
  ];

  const renderStateContent = () => {
    switch (activeState) {
      case 'loading':
        return (
          <div className="flex flex-col items-center justify-center p-12 text-center">
            <SafeIcon icon={FiLoader} className="w-12 h-12 text-pink-500 animate-spin mb-4" />
            <p className="font-mono text-xs text-[#aaa] tracking-widest uppercase">Initializing Neural Link...</p>
          </div>
        );
      case 'success':
        return (
          <div className="p-8 text-center border border-green-500/20 bg-green-500/5">
            <SafeIcon icon={FiCheckCircle} className="w-10 h-10 text-green-500 mx-auto mb-4" />
            <h5 className="font-bold text-white mb-2 uppercase tracking-wide">Sync Complete</h5>
            <p className="text-xs text-[#888]">All 24 high-resolution RAW files have been uploaded to the redundant server.</p>
          </div>
        );
      case 'warning':
        return (
          <div className="p-8 text-center border border-yellow-500/20 bg-yellow-500/5">
            <SafeIcon icon={FiAlertTriangle} className="w-10 h-10 text-yellow-500 mx-auto mb-4" />
            <h5 className="font-bold text-white mb-2 uppercase tracking-wide">Low Battery Warning</h5>
            <p className="text-xs text-[#888]">Main strobe battery at 12%. Connect to power to avoid synchronization lag.</p>
          </div>
        );
      case 'error':
        return (
          <div className="p-8 text-center border border-red-500/20 bg-red-500/5">
            <SafeIcon icon={FiAlertTriangle} className="w-10 h-10 text-red-500 mx-auto mb-4" />
            <h5 className="font-bold text-white mb-2 uppercase tracking-wide">Permit Denied</h5>
            <p className="text-xs text-[#888]">Location GPS coordinates detected outside authorized sector. Action required.</p>
          </div>
        );
      case 'empty':
        return (
          <div className="p-12 text-center">
            <div className="w-16 h-16 border-2 border-dashed border-[#333] rounded-full mx-auto mb-4 flex items-center justify-center">
              <SafeIcon icon={FiInfo} className="text-[#333]" />
            </div>
            <p className="font-mono text-xs text-[#555] tracking-widest uppercase">No data clusters found</p>
          </div>
        );
      default: return null;
    }
  };

  return (
    <CameraFrame className="overflow-hidden">
      <div className="flex border-b border-[#222]">
        {states.map(s => (
          <button
            key={s.id}
            onClick={() => setActiveState(s.id)}
            className={`flex-1 py-3 font-mono text-[9px] tracking-tighter transition-colors border-r border-[#222] last:border-r-0
              ${activeState === s.id ? 'bg-white/5 text-white' : 'text-[#555] hover:text-[#888]'}`}
          >
            {s.label}
          </button>
        ))}
      </div>
      <div className="bg-[#111] min-h-[220px] flex items-center justify-center p-6">
        {renderStateContent()}
      </div>
    </CameraFrame>
  );
};

export default StateSimulator;